import React from "react";
import { TreeSelect as FormikTreeSelect } from "formik-antd";

import "./styles.scss";

const CheckboxSelect = (props) => {
  const {
    data,
    customClass,
    placeholder,
    name,
    value,
    validate,
    disabled,
    handleChange,
  } = props;

  return (
    <FormikTreeSelect
      className={`multiple-select-box ${customClass}`}
      dropdownClassName="custom-select-tree-dropdown"
      placeholder={placeholder}
      treeCheckable={true}
      onChange={handleChange}
      treeData={data}
      showSearch={true}
      filterTreeNode={(inputValue, treeNode) => {
        const nodeTitle = treeNode?.title?.toLowerCase();
        const nodeValue = treeNode?.value?.toString();
        const inputTxt = inputValue?.toLowerCase()?.trim();
        return (
          nodeTitle?.indexOf(inputTxt) > -1 || nodeValue?.indexOf(inputTxt) > -1
        );
      }}
      showArrow={true}
      name={name}
      value={value}
      getPopupContainer={(trigger) => trigger.parentNode}
      validate={validate}
      disabled={disabled}
      maxTagCount="responsive"
    />
  );
};

export default CheckboxSelect;
